/**
 * Plain-language tooltips for finance managers (not technical).
 */

export const METRIC_HELP = {
  mtd_net_income: {
    title: "Net income (this month)",
    body: "Money left after all income minus all expenses in the current calendar month. Comes from posted journal entries on income and expense accounts.",
    source: "Finance V2 journals · Reports → Profit & Loss",
  },
  mtd_income: {
    title: "Revenue (this month)",
    body: "Total sales and other income recorded this month. Includes gym, PT, cafe, and other revenue accounts from your chart of accounts.",
    source: "Sales journals + mapped package types",
  },
  mtd_expense: {
    title: "Expenses (this month)",
    body: "Total operating costs posted this month: payroll, rent, supplies, legacy expenses, and manual entries.",
    source: "Expense journals and imports",
  },
  total_ar: {
    title: "Outstanding receivables",
    body: "Amount customers still owe on orders (pending payments). This is from order payment records, not cash in bank.",
    source: "Orders with pending balance",
  },
  gl_ar_balance: {
    title: "A/R on the books",
    body: "Balance in Accounts Receivable account (1200) from your ledger. Should be close to outstanding receivables over time.",
    source: "General ledger account 1200",
  },
  sales_synced_today: {
    title: "Sales synced today",
    body: "How many checkout sales were written to Finance V2 journals today. Each synced sale creates a balanced journal entry.",
    source: "Automatic sync after checkout",
  },
  posted_journals: {
    title: "Posted journals",
    body: "Total number of completed double-entry transactions in Finance V2. Each journal has equal debits and credits.",
    source: "All modules combined",
  },
  sync_failed: {
    title: "Sync issues",
    body: "Historical or live records that could not be converted to journals. Use Import & Sync tab to retry.",
    source: "Sync log",
  },
  journals_mtd: {
    title: "Journals this month",
    body: "Number of completed journal entries dated in the current calendar month.",
    source: "Posted journals by entry date",
  },
};

export const CHART_HELP = {
  pnl_overview: {
    title: "Income vs expenses",
    body: "Compares this month's revenue, expenses, and what is left (net income). Use Reports for a detailed breakdown by account.",
  },
  journal_sources: {
    title: "Where entries came from",
    body: "Shows how many journal entries were created from sales, expenses, payroll, opening balances, and imports. Helps you see which modules are feeding the books.",
  },
  ar_aging: {
    title: "Who owes money (aging)",
    body: "Splits pending customer balances by how long they have been outstanding. Use Receivables screen for client-by-client detail.",
  },
  sales_sync: {
    title: "Sales import status",
    body: "How many past orders are eligible for Finance V2, how many are already in the books, and how many still need import.",
  },
};

export const QUICK_LINK_HELP = {
  setup: "One-time wizard: company name, chart of accounts, opening balances, and mappings.",
  reports: "Profit & Loss, trial balance, and balance sheet from your posted journals.",
  journals: "List of every journal entry — search by date or reference.",
  import: "Bring old sales, expenses, and payroll into Finance V2 in batches.",
};
